/* Stylesheet */

.filter_label {
  margin: 0px 0px 16px 12px;

  .label {
    font-size: 14px;
    color: var(--ion-color-text-secondary);
  }
}
